@if (dataReady) {
  <!--  Content  -->
  <div class="st-drawer-wrapper">
    <div class="st-drawer-header" style="padding: 0 !important;">
      @if (step !== 2) {
        <h1 class="text-header-24 text-semibold">Flujos</h1>
      }
      @if (step === 2) {
        <div class="st-header-inner-group flex-center gap-100">
          <button (click)="cancelAddOrEditEvent()" nz-button nzType="text" nzSize="default" nzShape="circle" class="text-btn-16">
            <app-st-icon class="flex-center" [bold]="true" name="arrow_back"></app-st-icon>
          </button>
          @if (selectedEvent?.name) {
            <span class="text-header-18 text-semibold">Editar Evento "{{selectedEvent?.name}}"</span>
          }
          @if (!selectedEvent) {
            <span class="text-header-18 text-semibold">Añadir Evento</span>
          }
        </div>
      }
      @if (step !== 2) {
        <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
      }
    </div>

    <!--  Contenido de Flujo  -->
    @if (step === 1) {
      <div class="flow-content-wrapper">
        <span class="text-label-14 text-dark">
          El flujo es la secuencia de eventos que sigue un servicio hasta completarse. Puedes usar un flujo que se haya
          predefinido en <a href="http://localhost">Catálogos > Flujos</a> o adaptarlo para este servicio si lo necesitas.
        </span>

        <!-- Select para seleccionar el flujo -->
        <form class="st-form" nz-form [formGroup]="serviceForm">
          <nz-form-item hidden style="margin: 0">
            <nz-form-label [nzSpan]="24" nzRequired>Flujo</nz-form-label>
            <nz-form-control [nzErrorTip]="'Este campo es requerido'">
              <nz-select [nzSuffixIcon]="customSelectIcon" nzSize="large" formControlName="flow" nzShowSearch
                         (ngModelChange)="selectFlow($event)" [compareWith]="compareById">
                @for (flow of flowsList; track flow) {
                  <nz-option [nzLabel]="flow.name" [nzValue]="flow"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item style="margin-top: 24px;">
            <nz-form-label [nzSpan]="24">Nombre del flujo a editar o crear</nz-form-label>
            <nz-form-control>
              <input type="text" nzSize="large" nz-input [(ngModel)]="flowName" [ngModelOptions]="{standalone: true}"
                     placeholder="Introduce Nombre del Evento..." [readOnly]="nzData.readonly" />
            </nz-form-control>
          </nz-form-item>
        </form>

        <!-- Lista de eventos del flujo dado -->
        @if (events) {
          <app-event-cards-dragables
                                     [events]="events"
                                     [isEditing]="!nzData.readonly"
                                     (openAddOrEditEvent)="openAddOrEditEvent($event)"
          ></app-event-cards-dragables>
        }
      </div>
    }

    <!--  Contenido de Eventos y Activator  -->
    @if (step === 2 && eventForm && activatorForm) {
      <div class="flow-content-wrapper">
        <app-event-activator-section
          [event]="selectedEvent"
          [eventsLenght]="events.length"
          [(activatorForm)]="activatorForm"
          [(eventForm)]="eventForm"
        ></app-event-activator-section>
      </div>
    }

    <!--  Footer  -->
    <div class="st-drawer-footer flex-center gap-400">
      <button (click)="step===2?step = 1:close()"
              class="text-btn-14" nz-button nzType="default" nzShape="round" nzSize="large">
        <span>Cancelar</span>
      </button>

      @if (step === 1) {
        <div class="flex-center-between gap-200" style="width: 100%">

          @if (nzData.flowId && !nzData.readonly) {
            <button (click)="editFlow()" [disabled]="!isValid()"
                    style="margin-left: auto"
                     class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
              @if (procesingRequest !== 2) {
                <app-st-icon class="prefix" [name]="'edit'" [bold]="true"></app-st-icon>
              }
              @if (procesingRequest === 2) {
                <app-st-icon class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
              }
              <span>Guardar flujo</span>
            </button>
          }

          @if (!nzData.flowId) {
            <button style="margin-left: auto" (click)="createEventsEntities(false)" [disabled]="!isValid()"
                    class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
              @if (procesingRequest !== 1) {
                <app-st-icon class="prefix" [name]="'add'" [bold]="true"></app-st-icon>
              }
              @if (procesingRequest === 1) {
                <app-st-icon class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
              }
              <span>Crear flujo</span>
            </button>
          }
        </div>
      }

      @if (step === 2) {
        <button [disabled]="!isFormsValids()" (click)="confirmAddOrEditEvent()"
                class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
          <span>{{ selectedEvent ? 'Guardar' : 'Añadir' }} Evento</span>
        </button>
      }
    </div>
  </div>


}

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>
<ng-template #customClearIcon>
  <app-st-icon class="custom-clear" name="close"></app-st-icon>
</ng-template>

<!--  Notification  -->
<ng-template #notificationTmpl>
  @if (notRef) {
<app-toast [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor" [showUndo]="toastConfig.showUndo"
    [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
  }
</ng-template>
<ng-template #iconSelectTpmpl let-selected>
  <app-st-icon [name]="selected.nzValue"></app-st-icon>
</ng-template>

<ng-template #colorSelectTpmpl let-selected>
  <app-st-icon [color]="selected.nzValue" [filled]="true" name="fiber_manual_record"></app-st-icon>
</ng-template>

